/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Admin_Aianswer1Inputs */

const zh_landing_admin_aianswer1 = /** @type {(inputs: Landing_Admin_Aianswer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`光合作用让绿色植物利用阳光制造食物。叶子吸收二氧化碳，根部吸收水分，植物把它们结合在一起生成糖分，并释放出供呼吸的氧气。`)
};

const en_landing_admin_aianswer1 = /** @type {(inputs: Landing_Admin_Aianswer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photosynthesis allows green plants to create food using sunlight. Leaves absorb carbon dioxide, and roots take in water. The plant combines these to produce sugar and releases oxygen for breathing.`)
};

const es_landing_admin_aianswer1 = /** @type {(inputs: Landing_Admin_Aianswer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La fotosíntesis permite a las plantas verdes crear alimento usando la luz solar. Las hojas absorben dióxido de carbono y las raíces toman agua. La planta combina ambos para producir azúcar y libera oxígeno para respirar.`)
};

/**
* | output |
* | --- |
* | "Photosynthesis allows green plants to create food using sunlight. Leaves absorb carbon dioxide, and roots take in water. The plant combines these to produce ..." |
*
* @param {Landing_Admin_Aianswer1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const landing_admin_aianswer1 = /** @type {((inputs?: Landing_Admin_Aianswer1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Admin_Aianswer1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_admin_aianswer1(inputs)
	if (locale === "en") return en_landing_admin_aianswer1(inputs)
	return es_landing_admin_aianswer1(inputs)
});
export { landing_admin_aianswer1 as "landing_admin_aiAnswer" }